module.exports = {
  apollo: require('./apollo.json'),
  cityMap: require('./cityMap.json'),
  timezone: require('./timezone.json'),
  countryTimezone: require('./countryTimezone.json')
};
